import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { changeValue as cv, indicatorsLoaded as il, storeIndicators as si, clearState as cs } from "./ducks";
import { Row, Col } from "react-flexbox-grid";
import TypingFilter from "./typingFilter";
import SelectDisease from "./selectDisease";
import { YearSelectorRedux as YearSelector } from "./year-selector";
import LayerSelector from "./layer";
import { clearState as csd } from "../data/ducks";

class FiltersBar extends Component {
  componentWillMount() {
    this.props.clearState();
  }

  handleChangeSelectDisease(key, value) {
    this.props.changeValue(key, value);
    this.props.changeValue("year", "");
    this.props.changeValue("typing", "");
    this.props.changeValue("layer", "");
    this.props.clearStateData();
  }

  handleChangeYears(key, value){
    this.props.changeValue(key, value);
    this.props.changeValue("layer", "");
    this.props.clearStateData();
  }

  handleChangeTyping(key, value){
    this.props.changeValue(key, value);
    this.props.changeValue("year", "");
    this.props.changeValue("layer", "");
    this.props.clearStateData();
  }

  render() {
    const { typing, disease, year, layer, changeValue, indicatorsLoaded, storeIndicators, indicator } = this.props;

    return (
      <Row>
        <Col xs={12} md={12} lg={5}>
          <SelectDisease
            value={disease}
            handleChange={(key, value) => this.handleChangeSelectDisease(key, value)}
            handleLoad={indicatorsLoaded}
            storeIndicators={storeIndicators}
            indicator={indicator}
          />
        </Col>
        <Col xs={12} md={12} lg={2}>
          <TypingFilter
            value={typing}
            handleChange={(key, value) => this.handleChangeTyping(key, value)}
            placeholder="Tipificación"
            disabled={disease === ""}
            indicator={disease}
          />
        </Col>
        <Col xs={12} md={12} lg={2}>
          <YearSelector value={year} handleChange={(key, value) => this.handleChangeYears(key, value)} />
        </Col>
        <Col xs={12} md={12} lg={3}>
          <LayerSelector 
            value={layer} 
            handleChange={changeValue}
            indicator={disease}
            typing={typing}
            years={year}
          />
        </Col>
      </Row>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeValue: cv,
      indicatorsLoaded: il,
      storeIndicators: si,
      clearState: cs,
      clearStateData : csd
    },
    dispatch
  );
}

function mapStateToProps({ filters }) {
  return {
    typing: filters.get("typing"),
    disease: filters.get("disease"),
    type: filters.get("type"),
    year: filters.get("year"),
    layer: filters.get("layer")
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FiltersBar);



// WEBPACK FOOTER //
// ./src/components/filters/index.js